import { render, staticRenderFns } from "./case-update-import.vue?vue&type=template&id=07da4b0c&scoped=true"
import script from "./case-update-import.vue?vue&type=script&lang=ts"
export * from "./case-update-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da4b0c",
  null
  
)

export default component.exports